import gsap from "gsap";
if (document.querySelector(".showcase__wrap") && !window.isMobile) {
  let pinWrap = document.querySelector(".showcase__wrap");
  let pinWrapWidth = pinWrap.offsetWidth;
  let horizontalScrollLength = pinWrapWidth - window.innerWidth;

  gsap.to(".showcase__wrap", {
    scrollTrigger: {
      //   scroller: pageContainer, //locomotive-scroll
      scroller: ".scrollContainer",
      scrub: true,
      trigger: ".showcase",
      pin: true,
      anticipatePin: 1,
      start: "top top",
      refreshPriority: 1000,
      //   end: pinWrapWidth
      end: "bottom bottom-=" + pinWrapWidth + "px",
    },
    x: -horizontalScrollLength,
    ease: "none",
  });
}
